import { render, staticRenderFns } from "./IconDashboardCard.vue?vue&type=template&id=725d45da"
import script from "./IconDashboardCard.vue?vue&type=script&lang=js"
export * from "./IconDashboardCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports